import React, { Component } from 'react';

import renderHTML from 'react-render-html';

class TabButton extends Component {

	constructor() {
        super();

        this.state = {
            class: '',
            more_text: 'ver mais'
        };

        this.hancleClick = this.hancleClick.bind(this);
        this.scrollToMyRef = this.scrollToMyRef.bind(this);

        this.myRef = React.createRef();
	}

    componentDidMount() {
        this.setState({ class: 'tabs__header__button--' + this.props.color });
    }

    componentWillUnmount() {
    }

    // scrollToMyRef = () => window.scrollTo({ top: parseInt(this.myRef.current.offsetTop) - 50, behavior: 'smooth', });
    scrollToMyRef = () => {
        let top = parseInt(this.myRef.current.offsetTop) - 50;

        if (document.documentMode || /Edge/.test(navigator.userAgent)) {
            console.log('Hello Microsoft User!');
            window.scrollTo( 0, top );
        } else {
            console.log('Hello Other Browser User!');
            window.scrollTo({ top: top, behavior: 'smooth', })
        }
    }

    hancleClick() {
        this.props.onClick();

        setTimeout(function() {
            this.scrollToMyRef();
        }.bind(this), 50);
    }

	render() {
        const itemActive = (this.props.active) ? "tabs__header__button--active" : "tabs__header__button--inactive";
        const classList = [
            "tabs__header__button",
            itemActive,
            this.state.class
        ];

        return (
            <div className={ classList.join(' ') } onClick={ this.hancleClick } ref={ this.myRef }>
                <div className="header_button">
                    <div className="content">
                        <div className="text">{ renderHTML(this.props.title) }</div>
                        <div className="hover">
                            <div className="svg"><svg data-name="Agrupar 149" xmlns="http://www.w3.org/2000/svg" width="33.15" height="33.15"><g data-name="Agrupar 148" fill="#1a3e7e"><path data-name="Caminho 614" d="M16.575 0A16.575 16.575 0 1 0 33.15 16.575 16.593 16.593 0 0 0 16.575 0zm0 30.976a14.4 14.4 0 1 1 14.4-14.4 14.417 14.417 0 0 1-14.4 14.4z"/><path data-name="Caminho 615" d="M23.162 15.488h-5.5v-5.5a1.087 1.087 0 0 0-2.174 0v5.5h-5.5a1.087 1.087 0 1 0 0 2.174h5.505v5.5a1.087 1.087 0 0 0 2.174 0v-5.5h5.5a1.087 1.087 0 0 0 0-2.174z"/></g></svg></div>
                            <span className="text_normal">ver mais</span>
                            <span className="text_active">fechar</span>
                        </div>
                    </div>
                </div>
            </div>
    	);
	}
}

export { TabButton };